import { render, staticRenderFns } from "./Lgx368769034444865536.vue?vue&type=template&id=58c107f3&scoped=true&"
import script from "./Lgx368769034444865536.vue?vue&type=script&lang=js&"
export * from "./Lgx368769034444865536.vue?vue&type=script&lang=js&"
import style0 from "./Lgx368769034444865536.vue?vue&type=style&index=0&id=58c107f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c107f3",
  null
  
)

export default component.exports